export default async function EditPlanAttributeApi(
    id,
    name
  ) {
    let res = "";
    try {
      const body = {
        id: id,
        name: name,
      };
      const token = "Bearer " + localStorage.getItem("authToken");
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      };
      await fetch(
        `${process.env.REACT_APP_API_URL}v1/plan-attributes/custom-attribute-name`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.error("Error editing plan attributes: ", error);
          res = error;
        });
    } catch (error) {
      console.error(error);
      res = error;
    }
  
    return res;
  }
  